var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "user-order" },
    [
      _c(
        "el-table",
        {
          attrs: {
            fit: "",
            height: "496",
            data: _vm.list,
            "header-cell-class-name": "table-header-cell",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: "订单号",
              prop: "orderNumber",
              width: "120",
              align: "center",
              fixed: _vm.device !== "mobile",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "支付单号",
              prop: "payNumber",
              width: "120",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "下单时间",
              prop: "orderTime",
              width: "100",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("div", [
                      _vm._v(_vm._s(_vm._f("filterDate")(row.orderTime))),
                    ]),
                    _c("div", [
                      _vm._v(_vm._s(_vm._f("filterTime")(row.orderTime))),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "商品信息", "min-width": "250" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return _vm._l(row.products, function (item, pid) {
                    return _c(
                      "div",
                      {
                        key: pid,
                        staticClass: "flex align-start just-between",
                      },
                      [
                        _c("el-image", {
                          staticClass: "product-cover",
                          attrs: {
                            src: item.cover,
                            "preview-src-list": [item.cover],
                            lazy: "",
                          },
                        }),
                        _c("div", { staticClass: "flex-sub" }, [
                          _vm._v(_vm._s(item.goodsName)),
                        ]),
                        _c("div", { staticClass: "sku-count" }, [
                          _vm._v(_vm._s(`x${item.skuCount}`)),
                        ]),
                      ],
                      1
                    )
                  })
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "配送方式",
              prop: "deliveryMethodName",
              width: "80",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "订单金额",
              prop: "orderPrice",
              "min-width": "90",
              align: "right",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    row.orderType === 72000
                      ? [
                          _c("div", { staticClass: "space-nowrap" }, [
                            _c("span", { staticClass: "bold" }, [
                              _vm._v("总金额："),
                            ]),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm._f("filterInteger")(row.orderPrice))
                              ),
                            ]),
                          ]),
                          _c("div", { staticClass: "space-nowrap" }, [
                            _c("span", { staticClass: "bold" }, [
                              _vm._v("积分："),
                            ]),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm._f("filterInteger")(row.orderPoint))
                              ),
                            ]),
                          ]),
                          _c("div", { staticClass: "space-nowrap" }, [
                            _c("span", { staticClass: "bold" }, [
                              _vm._v("券："),
                            ]),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm._f("filterInteger")(row.orderCoupon))
                              ),
                            ]),
                          ]),
                        ]
                      : row.orderType === 73000
                      ? [
                          _c("span", { staticClass: "bold" }, [
                            _vm._v("积分："),
                          ]),
                          _vm._v(
                            _vm._s(_vm._f("filterInteger")(row.orderPoint)) +
                              " "
                          ),
                        ]
                      : row.orderType === 75000
                      ? [
                          _c("div", { staticClass: "space-nowrap" }, [
                            _c("span", { staticClass: "bold" }, [
                              _vm._v("现金："),
                            ]),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm._f("filterPrice")(row.orderPrice))
                              ),
                            ]),
                          ]),
                          parseFloat(row.orderPoint) > 0
                            ? _c("div", { staticClass: "space-nowrap" }, [
                                _c("span", { staticClass: "bold" }, [
                                  _vm._v("积分："),
                                ]),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("filterPrice")(row.orderPoint)
                                    )
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                          parseFloat(row.orderCoupon) > 0
                            ? _c("div", { staticClass: "space-nowrap" }, [
                                _c("span", { staticClass: "bold" }, [
                                  _vm._v("券："),
                                ]),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("filterPrice")(row.orderCoupon)
                                    )
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                        ]
                      : row.orderType === 76000
                      ? [
                          _c("div", { staticClass: "space-nowrap" }, [
                            _c("span", { staticClass: "bold" }, [
                              _vm._v("积分："),
                            ]),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm._f("filterInteger")(row.orderPoint))
                              ),
                            ]),
                          ]),
                          _c("div", { staticClass: "space-nowrap" }, [
                            _c("span", { staticClass: "bold" }, [
                              _vm._v("券："),
                            ]),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm._f("filterInteger")(row.orderCoupon))
                              ),
                            ]),
                          ]),
                        ]
                      : row.orderType === 77000
                      ? [
                          row.payMethod === 0
                            ? [
                                _c("span", { staticClass: "bold" }, [
                                  _vm._v("积分："),
                                ]),
                                _vm._v(
                                  _vm._s(
                                    _vm._f("filterInteger")(row.orderPoint)
                                  ) + " "
                                ),
                              ]
                            : [
                                _c("div", { staticClass: "space-nowrap" }, [
                                  _c("span", { staticClass: "bold" }, [
                                    _vm._v("现金："),
                                  ]),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("filterPrice")(row.orderPrice)
                                      )
                                    ),
                                  ]),
                                ]),
                                row.payMethod === 2
                                  ? _c("div", { staticClass: "space-nowrap" }, [
                                      _c("span", { staticClass: "bold" }, [
                                        _vm._v("积分："),
                                      ]),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("filterPrice")(
                                              row.orderPoint
                                            )
                                          )
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                              ],
                        ]
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "状态",
              prop: "orderStatusName",
              width: "80",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    row.orderStatus >= 51
                      ? _c(
                          "el-tag",
                          {
                            attrs: {
                              type: "success",
                              size: "medium",
                              effect: "dark",
                            },
                          },
                          [_vm._v(_vm._s(row.orderStatusName))]
                        )
                      : row.orderStatus === 13
                      ? _c(
                          "el-tag",
                          {
                            attrs: {
                              type: "info",
                              size: "medium",
                              effect: "dark",
                            },
                          },
                          [_vm._v(_vm._s(row.orderStatusName))]
                        )
                      : row.orderStatus === 41
                      ? _c(
                          "el-tag",
                          {
                            attrs: {
                              type: "warning",
                              size: "medium",
                              effect: "dark",
                            },
                          },
                          [_vm._v(_vm._s(row.orderStatusName))]
                        )
                      : row.orderStatus === 21
                      ? _c(
                          "el-tag",
                          {
                            attrs: {
                              type: "danger",
                              size: "medium",
                              effect: "plain",
                            },
                          },
                          [_vm._v(_vm._s(row.orderStatusName))]
                        )
                      : _c(
                          "el-tag",
                          { attrs: { size: "medium", effect: "dark" } },
                          [_vm._v(_vm._s(row.orderStatusName))]
                        ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("pagination", {
        attrs: {
          total: _vm.total,
          page: _vm.queryParams.page,
          limit: _vm.queryParams.limit,
          layout: "total, sizes, prev, pager, next",
        },
        on: {
          "update:page": function ($event) {
            return _vm.$set(_vm.queryParams, "page", $event)
          },
          "update:limit": function ($event) {
            return _vm.$set(_vm.queryParams, "limit", $event)
          },
          pagination: _vm.fetchData,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }